import React from 'react'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import store from './store'
import { BrandProvider } from './Context/Brand/BrandContext'
import { PlatformBrandProvider } from './Context/PlatformBrand/PlatformBrandContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

const AppProviders = ({ children }) => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PlatformBrandProvider>
          <BrandProvider>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
          </BrandProvider>
        </PlatformBrandProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default AppProviders
